import './lib/edgeResilienceBoot';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';   // ou './App.css' caso você prefira manter
import App from './App';
import { restoreIdentityFromBackups, syncIdentityBackups } from './utils/identityBackup';
import { logUxEvent } from './telemetry/uxLogger';
import { captureUrlCoupon } from './lib/urlCoupon';

// Cupom vindo de link (?cupom=CODE): capturado antes do React montar, porque a
// navegação SPA e os redirects de rota descartam a query string muito antes do
// paywall abrir. O ConsultaChat aplica sozinho ao mostrar o preço.
captureUrlCoupon();

// Boot recovery (defesa em profundidade contra perda de LS):
// Antes do React montar, tenta restaurar identidade do paciente (patientId,
// fullName, email, cpf, phone) de cookie first-party ou IndexedDB caso o
// localStorage tenha sido limpo (Safari ITP, cache buster, modo privado, etc).
// Eh idempotente — se LS ja tem a chave, nao toca. Tudo silencioso.
//
// Logamos `identity_restored_from_backup` quando algo foi recuperado para
// medir taxa de incidencia da perda de LS em producao.
(async () => {
  try {
    const { restored } = await restoreIdentityFromBackups();
    const restoredKeys = Object.keys(restored || {});
    if (restoredKeys.length > 0) {
      try {
        logUxEvent('identity_restored_from_backup', {
          keys_count: restoredKeys.length,
          restored_patient_id: !!restored.patientId,
          restored_email: !!restored.patientEmail,
          restored_cpf: !!restored.patientCpf,
          restored_phone: !!restored.patientPhone,
          restored_full_name: !!restored.fullName,
          // detalhe sobre a fonte (cookie vs idb) — sem PII
          patient_id_source: restored.patientId || null,
          email_source: restored.patientEmail || null,
        });
      } catch {}
    }
  } catch {}

  // Depois de restaurar, espelha de volta para cookie + IDB o que estiver no
  // localStorage. A maior parte do app grava identidade direto em LS, sem
  // passar por `persistIdentityKey`, então sem esta reconciliação existe
  // identidade viva que nunca chega às camadas de backup — e o navegador,
  // que perde LS com muito mais frequência que o app nativo, fica sem nada
  // para restaurar no boot seguinte.
  try {
    const { mirrored } = syncIdentityBackups();
    if (mirrored.length > 0) {
      try {
        logUxEvent('identity_backup_synced', {
          keys_count: mirrored.length,
          synced_patient_id: mirrored.includes('patientId'),
        });
      } catch {}
    }
  } catch {}
})();

// Reconcilia também quando a aba volta ao primeiro plano: a identidade pode
// ter sido criada depois do boot (o patientId nasce no primeiro clique da
// Home) e essa é a última janela antes de um possível descarte de storage.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    try { syncIdentityBackups(); } catch {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
